__turbopack_context__.v({
  "content": "SettingCard-module__61pOBG__content",
  "description": "SettingCard-module__61pOBG__description",
  "end": "SettingCard-module__61pOBG__end",
  "root": "SettingCard-module__61pOBG__root",
  "signOut": "SettingCard-module__61pOBG__signOut",
  "title": "SettingCard-module__61pOBG__title",
});
